module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "odiac-ffco2-monthgrid-v2022.thumbnails.co2.acc3a2c0.png";